/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignaturePositionSchemaDto
 */
export interface SignaturePositionSchemaDto {
    /**
     * 
     * @type {number}
     * @memberof SignaturePositionSchemaDto
     */
    x?: number;
    /**
     * 
     * @type {number}
     * @memberof SignaturePositionSchemaDto
     */
    y?: number;
    /**
     * 
     * @type {number}
     * @memberof SignaturePositionSchemaDto
     */
    page?: number;
}

/**
 * Check if a given object implements the SignaturePositionSchemaDto interface.
 */
export function instanceOfSignaturePositionSchemaDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SignaturePositionSchemaDtoFromJSON(json: any): SignaturePositionSchemaDto {
    return SignaturePositionSchemaDtoFromJSONTyped(json, false);
}

export function SignaturePositionSchemaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignaturePositionSchemaDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'x': !exists(json, 'x') ? undefined : json['x'],
        'y': !exists(json, 'y') ? undefined : json['y'],
        'page': !exists(json, 'page') ? undefined : json['page'],
    };
}

export function SignaturePositionSchemaDtoToJSON(value?: SignaturePositionSchemaDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'x': value.x,
        'y': value.y,
        'page': value.page,
    };
}

